import React, {useState, useContext, useRef} from 'react'
import { NavLink } from 'react-router-dom'
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
// import Swiper core and required modules
import SwiperCore, {
    Pagination, 
    Autoplay, 
    Navigation, 
    Parallax} from 'swiper';

import { MouseContext } from "../../context/mouseContext" //cursor 
// Import Swiper styles
import 'swiper/swiper.min.css'
import 'swiper/components/pagination/pagination.min.css'
import 'swiper/components/navigation/navigation.min.css'

import {projectsData} from '../../fake-database/index';  //fake api
// Import home styles
import './home.css';
import arrow from '../../Assets/badges/arrow.svg' //arrow image

SwiperCore.use([Pagination, Autoplay, Navigation,Parallax]);
const Home = () => {
    //custom navigation
    const prevRef = useRef(null);
    const nextRef = useRef(null);
    //cursor
    const {  cursorChangeHandler } = useContext(MouseContext);
    //custom pagination
    const pagination = {
        "clickable": true,
        "renderBullet": function (index, className) {
                return (
                `<span class=${className}>  
                    <div class='mx-2 number'>0${index+1}</div> 
                    <div class="line"></div>
                </span>`
                );
              }
      }

      //swiper parallex
      const [parallexSwiper, setParallexSwiper] = useState(null);
      const parallexAmount = parallexSwiper ? parallexSwiper.width * 0.85 : 0;
      const parallexOpacity = 0.4;


      let test = () =>{
        // const slide =  document.querySelector('.hero-slider');
        // slide.classList.add('test')
            // if (slide.classList.contains('active') != true)
            // {
            //     slide.classList.add('test')
            // }
            // else{
                
            //     slide.classList.remove('active')
            // }
          
      }
    return (
        <Swiper 
            id="mainHeader"
            className="hero-slider"
            parallax={true}
            speed={500} 
            spaceBetween={0}
            slidesPerView={1}
            navigation={{
                prevEl: '.prev',
                nextEl: '.next',
            }}
            loop
            grabCursor={true} 
            onSlideChange={test}
            autoplay={{
                "delay": 3000,
                "disableOnInteraction": false
            }}
            pagination={pagination}
        >
            <div ref={prevRef}>Prev</div>
            <div ref={nextRef}>Next</div>
            
            {projectsData.project.filter(project => project.slide === true).map(project => (
                <SwiperSlide className="hero-slide"  key={project.id} >
                    <div className="slide-content">
                        <div className="text-white text-content">
                            <p className="mb-0 slide-title">Projects</p>
                            <h1 className="slide-name">
                                <NavLink 
                                    className="text-capitalize"
                                    to={'project/'+project.id}
                                    onMouseEnter={() => cursorChangeHandler("hovered")}
                                    onMouseLeave={() => cursorChangeHandler("")}
                                >
                                    {project.name}
                                </NavLink>
                            </h1>
                            <div className="arrows d-flex">
                                <div 
                                    className="prev d-flex justify-content-center align-items-center"
                                    onMouseEnter={() => cursorChangeHandler("hovered")}
                                    onMouseLeave={() => cursorChangeHandler("")}
                                >
                                    <img src={arrow} alt="arrow" width={18} height={18}/>
                                </div>
                                <div 
                                    className="next d-flex justify-content-center align-items-center"
                                    onMouseEnter={() => cursorChangeHandler("hovered")}
                                    onMouseLeave={() => cursorChangeHandler("")}
                                >
                                    <img src={arrow} alt="arrow" width={18} height={18}/>
                                </div>
                                
                            </div>
                        </div>
                        <div
                            className="slide-image"
                            data-swiper-parallax={parallexAmount}
                            data-swiper-parallax-opacity={parallexOpacity}
                        >
                            <picture>
                                <source  alt={project.imageAlt} srcSet={project.image[0].imagePath}/>
                                <img 
                                    src={project.image[0].imagePath} alt={project.imageAlt}
                                    className="img-fuild"
                                    data-swiper-parallax={parallexAmount}
                                    data-swiper-parallax-opacity={parallexOpacity}
                                    width={1470} height={970}
                                />
                            </picture>
                        </div>
                    </div>
                </SwiperSlide>
            ))}
        </Swiper>
    )
}
export default Home;